import { render, staticRenderFns } from "./TheoriesEdit.vue?vue&type=template&id=7ccb62a5&"
import script from "./TheoriesEdit.vue?vue&type=script&lang=js&"
export * from "./TheoriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports